import {injectable} from "inversify";
import {
    ReportTicketComparativeEntity
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export abstract class ReportTicketComparativeRepository {
    public abstract get(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<ReportTicketComparativeEntity>;

    public abstract exportHtml(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<void>;
}
